module.exports = __webpack_public_path__ + "img/图片.613be235.png";